import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetEventAccountStockQueryVariables = Types.Exact<{
  event_account_id: Types.Scalars['ID'];
  event_id: Types.Scalars['ID'];
  start_date?: Types.InputMaybe<Types.Scalars['String']>;
  end_date?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetEventAccountStockQuery = { __typename?: 'Query', getEventAccountStock: { __typename?: 'EventAccountStock', prices: Array<{ __typename?: 'EventAccountStockPrice', type: Types.EventAccountStockPriceType, id_number?: number | null, id_text?: string | null, price_in_cents: number, currency: string }>, container_types: Array<{ __typename?: 'ContainerType', id: number, name: string, image?: string | null }>, item_location_stock: Array<{ __typename?: 'ItemLocationStockEntry', id: string, name: string, container_deliveries: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, amount: number }>, containers_used: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, amount: number }>, container_returns: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, amount: number, amount_sealed: number }>, goodwill: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, amount: number, amount_sealed: number }>, container_station_deliveries: Array<{ __typename?: 'ContainerStationStockEntry', id: string, name: string, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null } }>, container_station_returns: Array<{ __typename?: 'ContainerStationStockEntry', id: string, name: string, item_type: { __typename?: 'ItemType', id: number, name: string, color_hex_code?: string | null, category: Types.ItemTypeCategory, epc_asset_id: number, image_url?: string | null } }>, asset_deliveries: Array<{ __typename?: 'ItemTypeAmount', item_type_id: number, item_type_name: string, item_type_image?: string | null, amount: number }>, asset_returns: Array<{ __typename?: 'ItemTypeAmount', item_type_id: number, item_type_name: string, item_type_image?: string | null, amount: number }>, container_totals: Array<{ __typename?: 'ContainerTypeAmount', container_type_id: number, amount: number }> }> } };


export const GetEventAccountStockDocument = gql`
    query GetEventAccountStock($event_account_id: ID!, $event_id: ID!, $start_date: String, $end_date: String) {
  getEventAccountStock(
    event_account_id: $event_account_id
    event_id: $event_id
    start_date: $start_date
    end_date: $end_date
  ) {
    prices {
      type
      id_number
      id_text
      price_in_cents
      currency
    }
    container_types {
      id
      name
      image
    }
    item_location_stock {
      id
      name
      container_deliveries {
        container_type_id
        amount
      }
      containers_used {
        container_type_id
        amount
      }
      container_returns {
        container_type_id
        amount
        amount_sealed
      }
      goodwill {
        container_type_id
        amount
        amount_sealed
      }
      container_station_deliveries {
        id
        name
        item_type {
          id
          name
          color_hex_code
          category
          epc_asset_id
          image_url
        }
      }
      container_station_returns {
        id
        name
        item_type {
          id
          name
          color_hex_code
          category
          epc_asset_id
          image_url
        }
      }
      asset_deliveries {
        item_type_id
        item_type_name
        item_type_image
        amount
      }
      asset_returns {
        item_type_id
        item_type_name
        item_type_image
        amount
      }
      container_totals {
        container_type_id
        amount
      }
    }
  }
}
    `;

/**
 * __useGetEventAccountStockQuery__
 *
 * To run a query within a React component, call `useGetEventAccountStockQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventAccountStockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventAccountStockQuery({
 *   variables: {
 *      event_account_id: // value for 'event_account_id'
 *      event_id: // value for 'event_id'
 *      start_date: // value for 'start_date'
 *      end_date: // value for 'end_date'
 *   },
 * });
 */
export function useGetEventAccountStockQuery(baseOptions: Apollo.QueryHookOptions<GetEventAccountStockQuery, GetEventAccountStockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventAccountStockQuery, GetEventAccountStockQueryVariables>(GetEventAccountStockDocument, options);
      }
export function useGetEventAccountStockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventAccountStockQuery, GetEventAccountStockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventAccountStockQuery, GetEventAccountStockQueryVariables>(GetEventAccountStockDocument, options);
        }
export type GetEventAccountStockQueryHookResult = ReturnType<typeof useGetEventAccountStockQuery>;
export type GetEventAccountStockLazyQueryHookResult = ReturnType<typeof useGetEventAccountStockLazyQuery>;
export type GetEventAccountStockQueryResult = Apollo.QueryResult<GetEventAccountStockQuery, GetEventAccountStockQueryVariables>;